import {OrbitComponent} from "../../../../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {GamePlayPcHeaderBarTopLeftEndSectionBox} from "../../../../boxes/sections/top-section/left/game-play-pc-header-bar-top-left-end-section.box";
import {GamePlayPcHeaderBarTopLeftSectionBox} from "../../../../boxes/sections/top-section/left/game-play-pc-header-bar-top-left-section.box";
import React from "react";
import {
    IGameContextViewModel
} from "../../../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {GamePlayPcHeaderBarGameTitleComponent} from "../../../game-title/game-play-pc-header-bar-game-title.component";
import {
    GamePlayPcHeaderBarVendorSessionIdComponent
} from "../../../vendor-session-id/game-play-pc-header-bar-vendor-session-id.component";
import {
    GamePlayPcHeaderBarTopLeftStartSectionBox
} from "../../../../boxes/sections/top-section/left/game-play-pc-header-bar-top-left-start-section.box";
import {GamePcHeaderBarClockComponent} from "../../../../../../common/parts/clock/game-pc-header-bar-clock.component";
import {
    BlankHorizontalSeparatorBox
} from "../../../../../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {
    MinimumGamblingAgeComponent
} from "../../../../../../../../responsible-gambling/minimum-gambling-age/minimum-gambling-age.component";

interface GamePlayPcHeaderBarTopLeftSectionComponentProps {
    gameContext: IGameContextViewModel;
    hideVendorGameSession?: boolean;
    renderStartSection?: () => React.ReactElement;
    renderEndSection?: () => React.ReactElement;
}
export const GamePlayPcHeaderBarTopLeftSectionComponent = observer(
    class GamePlayPcHeaderBarTopLeftSectionComponent extends OrbitComponent<GamePlayPcHeaderBarTopLeftSectionComponentProps> {

        private _renderStartSection = () => {
            if(this.props.renderStartSection) {
                return this.props.renderStartSection();
            }

            return (
                <GamePlayPcHeaderBarTopLeftStartSectionBox>
                    <GamePcHeaderBarClockComponent/>
                    <BlankHorizontalSeparatorBox/>
                    <MinimumGamblingAgeComponent/>
                    <BlankHorizontalSeparatorBox/>
                </GamePlayPcHeaderBarTopLeftStartSectionBox>
            );
        }

        private _renderEndSection = () => {
            if(this.props.renderEndSection) {
                return this.props.renderEndSection();
            }

            return (
                <GamePlayPcHeaderBarTopLeftEndSectionBox>
                    <GamePlayPcHeaderBarGameTitleComponent gameContext={this.props.gameContext}/>
                    <GamePlayPcHeaderBarVendorSessionIdComponent gameContext={this.props.gameContext} hide={this.props.hideVendorGameSession}/>
                </GamePlayPcHeaderBarTopLeftEndSectionBox>
            );
        }
        render() {
            return (
                <GamePlayPcHeaderBarTopLeftSectionBox>
                    {this._renderStartSection()}
                    {this._renderEndSection()}
                </GamePlayPcHeaderBarTopLeftSectionBox>
            )
        }
    }
);